class TicketsRoutesStore {
  get couponDetail() {
    return `/t/:code`;
  }

  get eventDetail() {
    return `/t/:code`;
  }

  get voucherDetail() {
    return `/:slug/vouchers`;
  }
}

const ticketsRoutesStore = new TicketsRoutesStore();

export default ticketsRoutesStore;
